import QuestionnaireLoading from '@/app/components/loading-screen/components/questionnaire-loading/questionnaire-loading';
import { RiskProcessingStatus } from '@/repositories/risk-processing-status.repository';
import QuestionnaireError from './components/questionnaire-error/questionnaire-error';
import useLoadingScreenController from './loading-screen.controller';

export default function LoadingScreenPage() {
  const { status, isFirstAssessment, isCalculationComplete, resetStatus } = useLoadingScreenController();

  switch (status) {
    case RiskProcessingStatus.processing:
      return (
        <QuestionnaireLoading
          isFirstTimeLoadingResults={isFirstAssessment}
          isCalculationComplete={isCalculationComplete}
        />
      );
    case RiskProcessingStatus.error:
      return <QuestionnaireError resetStatus={resetStatus} />;
    default:
      return null;
  }
}
